// Types para o App SIGMA Banca (baseado na API real)

export interface Trade {
  id: number
  user_id: number
  amount: number
  price: number
  type: 'buy' | 'sell'
  asset: string
  asset_url: string | null
  expiration_seconds: number
  expiration: string
  status: 'pending' | 'win' | 'loss' | 'open'
  demo: boolean
  created_at: string
  updated_at: string
  wallet_type: string
  profit: number
  close_price: number | null
  payout: number | null
  unique_id: string
  processed: boolean
  booster_id: number | null
  booster_percentage: number | null
  badge_bonus_percentage: number | null
  bonus_source: string | null
  is_copytrade: boolean
  copy_master_user_id: number | null
  copy_master_name: string | null
  notes?: string
}

export interface BankrollSettings {
  initial_balance: number
  max_risk_percent: number // % máximo por operação
  stop_loss_daily: number // perda máxima diária em R$
  take_profit_daily: number // meta de lucro diário em R$
  max_drawdown: number // drawdown máximo permitido
}

export interface Goal {
  id: string
  period: 'daily' | 'weekly' | 'monthly'
  target_amount: number
  start_date: string
  end_date: string
  achieved: boolean
  current_amount: number
}

export interface KPIs {
  current_balance: number
  initial_balance: number
  total_profit: number
  total_loss: number
  profit_factor: number
  win_rate: number
  total_trades: number
  winning_trades: number
  losing_trades: number
  avg_win: number
  avg_loss: number
  roi: number
  best_trade: number
  worst_trade: number
  current_streak: number // sequência atual (positivo = wins, negativo = losses)
  max_win_streak: number
  max_loss_streak: number
}

export interface DailyStats {
  date: string
  trades: number
  profit: number
  win_rate: number
}

export interface AssetStats {
  symbol: string
  name: string
  total_trades: number
  wins: number
  losses: number
  win_rate: number
  total_profit: number
  avg_profit: number
}

export interface MonthlyReport {
  month: string // YYYY-MM
  trades: number
  profit: number
  win_rate: number
  profit_factor: number
  best_day: DailyStats
  worst_day: DailyStats
}

// Perfil de Risco para Planilha SIGMA
export type RiskProfile = 'conservative' | 'moderate' | 'aggressive'

export const RISK_PROFILES = {
  conservative: { label: 'Conservador', percent: 0.01, range: '1,00%' },
  moderate: { label: 'Moderado', percent: 0.02, range: '2,00%' },
  aggressive: { label: 'Agressivo', percent: 0.05, range: '5,00%' },
} as const

export interface SpreadsheetRow {
  day: number
  date: string
  capitalAtual: number
  aportes: number
  valorOrdem: string
  valorPorEntrada: number
  qtEntradas: number
  lucroDiaReais: number
  lucroDiaPercent: number
}

export interface SpreadsheetTotals {
  totalLucroReais: number
  totalLucroPercent: number
  totalEntradas: number
}
